import { BouColor } from '@upright/ui/common/generic/global/bou-colors';
import { mobileOrNarrower, tabletOrWider } from '@upright/ui/common/generic/layout/breakpoint-utils';
import styled, { css } from 'styled-components';

const formModalHorizontalPadding = `
  padding: 0 2em;
`;

/* NOTE!
 * These components are ONLY meant to be used with FormModal.
 * If you want to use these somewhere else, copy the styles instead of importing these components.
 */

export const FormModalTopBar = styled.div`
  ${formModalHorizontalPadding}
  width: 100%;
  height: 4em;
  background-color: ${BouColor.TOOL_BACKGROUND_WHITE};
  border-bottom: 1px solid ${BouColor.TOOL_BORDER_LIGHTER_GRAY};
  padding-right: 5em;
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 9998;
  ${mobileOrNarrower(css`
    height: 5em;
  `)}
`;

export const FormModalContent = styled.div`
  ${mobileOrNarrower(css`
    max-height: calc(100vh - 8em);
  `)}
  ${formModalHorizontalPadding}
  overflow-y: auto;
  max-height: calc(
    88vh - 8em
  ); // This guarantees that FormModalBottomBar will stay visible no matter what the viewport height (takes into account both bars height, 4em + 4em) /RN.
`;

export const FormModalBottomBar = styled.div`
  border-top: 1px solid ${BouColor.TOOL_BORDER_LIGHTER_GRAY};
  background-color: ${BouColor.TOOL_BACKGROUND_WHITE};
  z-index: 9998;
  ${mobileOrNarrower(css`
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 1em;
  `)}
  /* A modal footer is a right-aligned action row (DESIGN.md, "Where the action row goes"), so the
     primary action is the last child and sits rightmost. This used to be row-reverse with
     space-between, which put the primary first in the DOM and last on screen — the tab order then
     disagreed with the reading order. Anything that belongs at the *left* end of the row, such as a
     status or error message, takes margin-right: auto in its own file instead. */
  ${tabletOrWider(css`
    ${formModalHorizontalPadding}
    height: 4em;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: var(--space__sm);
  `)}
`;
